import Vue from 'vue';

export const preferencesService = {
  async retrievePreferences(referenceNumber = null) {
    if (referenceNumber) {
      return Vue.axios.get(`/preferences/${referenceNumber}`).then(response => response.data);
    } else {
      return Vue.axios.get('/preferences').then(response => response.data);
    }
  },

  async addPreference(preference) {
    return Vue.axios
      .post('/preferences', {
        ...preference
      })
      .then(response => response.data);
  },
  async deletePreference(preferenceId) {
    return Vue.axios
      .delete('/preferences', {
        data: preferenceId
      })
      .then(response => response.data);
  },
  async updatePreference(preference) {
    return Vue.axios
      .put('/preferences', {
        ...preference
      })
      .then(response => response.data);
  }
};
